import React, { type ReactNode, type FC } from 'react';
import { InputText } from '@g2u/ui-kit';

import { AccountType, type WithOptionalDataTest } from 'types';
import { useEmailValidation } from './hooks/useEmailValidation';

export namespace InputEmail {
  export type Props = {
    name?: string;
    className?: string;
    label?: string | ReactNode;
    required?: boolean;
    placeholder?: string;
    initialValue?: string;
    disableEmailCheck?: boolean;
    isBusiness?: boolean;
    fullWidth?: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const {
      className,
      name = 'email',
      label = 'Email Address:',
      required = true,
      dataTestId = 'email',
      placeholder = 'Input',
      initialValue,
      disableEmailCheck,
      isBusiness,
      fullWidth = true,
      ...antProps
    } = props;
    const customerType = isBusiness ? AccountType.Company : AccountType.Personal;
    const { validateEmail, setIsValidationEnabled } = useEmailValidation(
      customerType,
      name,
      initialValue,
      disableEmailCheck,
      required,
    );

    return (
      <InputText.$
        dataTestId={dataTestId}
        name={name}
        className={className}
        label={label}
        required={required}
        validateFirst
        rules={[
          { required, message: 'Email is required' },
          {
            type: 'email',
            message: 'Incorrect email format',
          },
          { validator: validateEmail },
        ]}
        fullWidth={fullWidth}
        placeholder={placeholder}
        initialValue={initialValue}
        onChange={() => setIsValidationEnabled(true)}
        onBlur={() => setIsValidationEnabled(false)}
        {...antProps}
      />
    );
  };
}
